// extracted by mini-css-extract-plugin
export default {"containerTitle":"ActiveGame_containerTitle__EwHXp","containerHost":"ActiveGame_containerHost__4svJZ"};